var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { avatarHtml } from '@/support/String';
import { User } from '@/models/User';
import DataTable from '@/components/data-table/DataTable';
import ErrorHandler from '@/support/ErrorHandler';
let ResetUsersPasswordDialog = class ResetUsersPasswordDialog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.updatingPassword = {};
        this.newPassword = {};
        this.isSucess = {};
        this.hasErrors = {};
        this.tableVisibility = {
            checkboxes: false,
            limit: false,
        };
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    togglePasswordField(id) {
        this.$set(this.updatingPassword, id, !this.updatingPassword[id]);
        // we clear the password when input is not visible
        if (!this.updatingPassword[id] && this.newPassword[id]) {
            delete this.newPassword[id];
        }
    }
    resetValidationState(id) {
        const field = this.$refs[`field-${id}`];
        field.$el.classList.remove('error');
        field.$el.classList.remove('success');
    }
    // #endregion
    // #region Async methods
    async updateUserPassword(id) {
        const response = await new User({ id })
            .update({ password: this.newPassword[id] })
            .catch((error) => {
            this.$refs[`field-${id}`].$el.classList.add('error');
            ErrorHandler.network(error);
        });
        if (response) {
            return true;
        }
        return false;
    }
    // #endregion
    // #region Getters & Setters
    get actions() {
        return [
            {
                type: 'edit',
                label: 'edit',
                icon: 'edit',
                visible: (vm, user) => {
                    return !(user && user.id && this.updatingPassword[user.id]);
                },
                action: (vm, user) => {
                    if (!(user && user.id)) {
                        return;
                    }
                    this.togglePasswordField(user.id);
                },
            },
            {
                type: 'save',
                label: 'save',
                icon: 'save',
                visible: (vm, user) => {
                    return !!(user && user.id && this.updatingPassword[user.id]);
                },
                action: async (vm, user) => {
                    if (!(user && user.id)) {
                        return;
                    }
                    this.resetValidationState(user.id);
                    const isUpdated = await this.updateUserPassword(user.id);
                    if (isUpdated) {
                        this.$refs[`field-${user.id}`].$el.classList.add('success');
                        setTimeout(() => {
                            this.togglePasswordField(user.id);
                        }, 1000);
                    }
                },
            },
            {
                type: 'cancel',
                label: 'cancel',
                icon: 'cancel',
                visible: (vm, user) => {
                    return !!(user && user.id && this.updatingPassword[user.id]);
                },
                action: (vm, user) => {
                    if (!(user && user.id)) {
                        return;
                    }
                    this.togglePasswordField(user.id);
                },
            },
        ];
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc(`roles.student`, 1),
                plural: this.$tc(`roles.student`, 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                    width: '80px',
                },
                {
                    slot: 'name',
                    text: this.$tc('roles.student', 1).toString(),
                    value: 'name',
                    width: '70%',
                },
                {
                    slot: 'password',
                    text: this.$t('password').toString(),
                    value: 'password',
                    width: '30%',
                },
            ],
            actions: this.actions,
            filters: [],
            model: new User().filter(this.filters),
        };
    }
};
__decorate([
    Prop({ default: () => ({}) }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], ResetUsersPasswordDialog.prototype, "filters", void 0);
ResetUsersPasswordDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], ResetUsersPasswordDialog);
export default ResetUsersPasswordDialog;
